import { thirdPartyCollectSources } from '@tm/client-app/src/survey/editor-v3/Canvas/Thanks/ThirdPartyCollect/sources'
import { ThirdPartyCollectData } from '@tm/types/survey/entities'
import { styled } from 'goober'
import React from 'react'

const ThirdPartyCollectContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2.5em;
`

const ThirdPartyCollectLinkContainer = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
  max-width: 600px;
`

const ThirdPartyCollectLink = styled('a')`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px 24px 16px;
  gap: 8px;
  width: 137px;
  height: 136px;
  background: #f9fafb;
  border-radius: 8px;
  flex: none;
  order: 0;
  flex-grow: 0;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  color: #636e81;
  text-decoration: none;
  transition: 0.3s background ease-in-out, 0.3s color ease-in-out;
  &:hover {
    background: #e6e6e8;
    color: #232323;
  }
`

const ThirdPartyCollectIcon = styled<{ logo: string }>('div')`
  background: ${props => `url(${props.logo})`};
  height: 50px;
  width: 100%;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;
`

const ThirdPartyCollectValidationError = styled<{ errorColor?: string }>('div')`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  right: 0;
  top: 0;
  height: 30px;
  background: ${props => (props.errorColor ? props.errorColor : `#E4422A`)};
  color: #ffffff;
  white-space: nowrap;
`

export const ThirdPartyCollect = ({
  value,
  validationErrors,
  errorColor,
  onLinkClick,
}: {
  value?: ThirdPartyCollectData
  validationErrors?: Record<string, string>
  errorColor?: string
  onLinkClick?: (event: React.MouseEvent) => void
}) => {
  if (!value) {
    return null
  }

  if (!value.sources || (value.sources && !value.sources.length)) {
    return null
  }

  return (
    <ThirdPartyCollectContainer>
      <ThirdPartyCollectLinkContainer>
        {value.sources.map(source => {
          const tpcSource = thirdPartyCollectSources.find(tpcSource => tpcSource.name === source.source)
          return (
            <ThirdPartyCollectLink
              onClick={onLinkClick}
              href={source.url}
              rel="noreferrer"
              target="_blank"
              key={source.id}>
              {!!validationErrors && validationErrors[source.id] && (
                <ThirdPartyCollectValidationError errorColor={errorColor}>
                  {validationErrors[source.id]}
                </ThirdPartyCollectValidationError>
              )}
              <ThirdPartyCollectIcon logo={tpcSource?.logo || ''} />
              {source.name}
            </ThirdPartyCollectLink>
          )
        })}
      </ThirdPartyCollectLinkContainer>
    </ThirdPartyCollectContainer>
  )
}
